// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { ClientApplication } from '../../client';
import type {
  ListFilm,
  ListFilmData,
  ListFilmPatch,
  ListFilmQuery,
  ListFilmsService,
} from './list-films.class';

export type { ListFilm, ListFilmData, ListFilmPatch, ListFilmQuery };

export type ListFilmsClientService = Pick<ListFilmsService, (typeof listFilmsMethods)[number]>;

export const listFilmsPath = 'api/list-films';

export const listFilmsMethods: Array<keyof ListFilmsService> = [
  'remove',
  'patch',
  'addExistingFilm',
  'addNewFilm',
  'getList',
  'updateListPositions',
  'importList',
  'fillSlot',
];

export const listFilmsClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(listFilmsPath, connection.service(listFilmsPath), {
    methods: listFilmsMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [listFilmsPath]: ListFilmsClientService;
  }
}
